module.exports = __webpack_public_path__ + "static/media/live-online-mockup.3873d772.png";